import React, { Component } from 'react';
import Banner from './layout/Banner';
import global from '../global';
import { observer } from "mobx-react";
import { browserHistory } from 'react-router';
import Calendar from 'react-github-contribution-calendar';
import { Link } from 'react-router';

var panelColors = [
  '#EEEEEE',
  '#888',
  '#777',
  '#555',
  '#111'
];

const Home = observer(class Home extends Component {

  constructor(props) {
    super(props);
  }

  eventToggleSidebar(e) {
    // browserHistory.replace('/services');
    //e.preventDefault();
    global.closeSidebar();
  }

  render() {
    console.log('global.githubContributions', global.store.githubContributions);
    return (
      <div className="posts">
        <div className="post banner">
          <h1 className="post-title">
            I build <em>scalable</em>, <em>maintainable</em> and <em>secure</em> enterprise web, & mobile applications.
          </h1>
          <p>
            for <em>agencies</em>, <em>start-ups</em> and sometimes, <em>myself</em>.
            <Link to="/portfolio" onClick={this.eventToggleSidebar}> View Projects</Link>
          </p>
        </div>

        <div style={{ paddingBottom: '20px' }}>
          <Link to="/portfolio" className="btn btn-primary" style={{maxWidth: '50%'}} onClick={this.eventToggleSidebar}> View Projects</Link>
        </div>

        <div className="post clearfix" style={{ width: '100%', textAlign: 'right' }}>
          {(global.store.githubContributions) && <Calendar panelColors={panelColors} values={global.store.githubContributions} />}
          <a href="https://github.com/codingmalkio" style={{ fontSize: 16, padding: '2px 30px'}}>Github</a>
        </div>

        <div className="post">
          <h2>Technologies I build with:</h2>
          <div className="row">
            <div className="col-sm-3 skill-item ">
              <h4>Client Side JS</h4>
              <ul className="">
                <li>
                  <em><b>*</b><b>*</b>React</em>
                  <ul>
                    <li><em><b>*</b>Mobx</em></li>
                    <li><em><b>*</b>Hooks API</em></li>
                    <li><em><b>*</b>Zustand</em></li>
                  </ul>
                </li>
                <li>
                  <em><b>*</b><b>*</b><b>*</b>jQuery</em>
                </li>
                <li>
                  <em>Vanilla JS</em>
                </li>
              </ul>
            </div>

            <div className="col-sm-3 skill-item ">
              <h4>Server Side JS</h4>
              <ul>
                <li>
                  <em>MongoDB</em>
                </li>
                <li>
                  <em><b>*</b>Node</em>
                  <ul>
                    <li>
                      <em><b>*</b>Express</em>
                    </li>
                    <li>
                      <em><b>*</b>AdonisJS</em>
                    </li>
                    <li>
                      <em>Hapi</em>
                    </li>
                    <li>
                      <em>NextJS</em>
                    </li>
                    <li>
                      <em>NestJS</em>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="col-sm-3 skill-item ">
              <h4>Dev Tools</h4>
              <ul className="clearfix">
                <li><em>Webpack</em></li>
                <li><em><b>*</b>Gulp</em></li>
                <li><em><b>*</b>Grunt</em></li>
                <li><em>Git</em></li>
                <li><em>Bower</em></li>
                <li><em>Npm</em></li>
              </ul>
            </div>

            <div className="col-sm-3 skill-item ">
              <h4>Client Side Mobile</h4>
              <ul className="">
                <li>
                  <em><b>*</b><b>*</b>React Native</em>
                  <em><b>*</b><b>*</b>Expo</em>
                </li>
                <li>
                  <em>HTML5</em>
                  <ul>
                    <li>
                      <em><b>*</b>WebView</em>
                    </li>

                  </ul>
                </li>
              </ul>

              <h4 style={{ marginTop: 40 }}>Testing</h4>
              <ul>
                <li><em>Jest</em></li>
              </ul>
            </div>

          </div>

          <div className="exclaimation">
            <em hidden><b>**</b> Yep, I know React can be used on the server side too. This site is Isomorphical rendered.</em>
          </div>
        </div>

        <div className="post ">
          <hr />
          <h2>Technologies I previously worked with:</h2>
          <div className="row">

            <div className="skill-item col-sm-3">
              <h4>Server Side PHP</h4>
              <ul>
                <li>
                  <em>MySQL</em>
                </li>
                <li>
                  <em><b>*</b>PHP</em>
                  <ul>
                    <li>
                      <em><b>*</b>Phalcon</em>
                    </li>
                    <li>
                      <em>Code Igniter</em>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="skill-item col-sm-3">
              <h4>Client Side Mobile</h4>
              <ul>
                <li>
                  <em>Java Android</em>
                  <ul>
                    <li><em>SqlLite</em></li>
                  </ul>
                </li>
              </ul>

              <h4 style={{ marginTop: 120 }}>Server Side JS (BAAS)</h4>
              <ul>
                <li>
                  <em>Parse.com</em>
                </li>
                <li>
                  <em>Backendless</em>
                </li>
              </ul>

            </div>
            <div className="skill-item col-sm-3">
              <h4>CMS</h4>
              <ul>
                <li>
                  <em>Magento</em>
                </li>
                <li>
                  <em>Wordpress</em>
                </li>
              </ul>
            </div>
            <div className="skill-item col-sm-3">
              <h4>Hosting</h4>
              <ul>
                <li>
                  <em>Rackspace</em>
                </li>
                <li>
                  <em>Digital Ocean</em>
                </li>
                <li>
                  <em>Heroku</em>
                </li>
                <li>
                  <em>Cloudflare</em>
                </li>
                <li>
                  <em>AWS</em>
                </li>
                <li>
                  <em>Vercel</em>
                </li>
                <li>
                  <em>Render</em>
                </li>
              </ul>
            </div>

          </div>



        </div>

        {/* <div className="post clearfix hidden">
				<h2>Companies I have worked with:</h2>
				<ul className="clients" hidden>
					<li className="goldmans-logo">Goldman Sachs</li>
					<li className="orange-logo">Orange</li>
					<li className="tesco-logo">Tesco</li>
					<li className="timeout-logo">Timeout</li>
					<li className="wiley-logo">John Wiley and Sons</li>
					<li className="covestor-logo">Covestor</li>
					<li className="shipserv-logo">Shipserv</li>
				</ul>
			</div> */}

        <div style={{ paddingBottom: '20px' }}>
          <Link to="/portfolio" className="btn theme-text-primary" style={{maxWidth: '50%', backgroundColor: 'rgba(255,255,255,0.8'}} onClick={this.eventToggleSidebar}> View Projects</Link>
        </div>

        <Banner />
      </div>
    );
  }
})
export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js